// extracted by mini-css-extract-plugin
export default {"backdrop":"modal_backdrop__6uXVV","modal":"modal_modal__+5JdP","header":"modal_header__mQ+f4","closeBtn":"modal_closeBtn__mT5Zg","body":"modal_body__8JzZs"};